// Import all images in assets (SVG, PNG, JPG, JPEG)
const images = import.meta.glob("../assets/**/*.{svg,png,jpg,jpeg}", {
    eager: true,
    query: "?url",
    import: "default",
}) as Record<string, string>; // <-- cast to string;

export const getImageUrl = (filePath: string): string => {
    /**
     * Returns the path of an image from the assets folder
     * @param {string} filePath - the path name
     * @returns {string}
     */
    const key = `../assets/${filePath}`;
    const url = images[key];
    if (!url) {
        console.warn(`Image not found: ${filePath}`);
        return ""; // fallback as string
    }
    return url;
};

export const getChipColor = (
    selectedStatus: string,
    status: string,
    hover: boolean | undefined,
) => {
    /**
     * Returns different colors based on whether the status is selected
     * or hovered
     * @param {string} selectedStatus
     * @param {string} status - status from the list
     * @param {boolean | undefined} hover
     * @returns {string}
     * */
    if (!hover && status !== selectedStatus) {
        return "#ffffff";
    } else if (hover && status !== selectedStatus) {
        return "#0DA7F8";
    } else {
        return "#005B8A";
    }
};

export const getChipVariant = (selectedStatus: string, status: string) => {
    /**
     * Returns different variants based on whether the status is selected
     * @param {string} selectedStatus
     * @param {string} status
     * @returns {string}
     * */
    return status === selectedStatus ? "flat" : "outlined";
};
